import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

/// styles
import { useSnackbar } from 'notistack';
import { Reducers } from '../../../store/store';
import { resetMessageStore } from './snackbarNotificationSlice';

const SnackbarNotification = () => {
    const dispatch = useDispatch();
    const snackbarNotificationReducer = useSelector((state: Reducers) => state.snackbarNotifications);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        let message = '';

        message = snackbarNotificationReducer?.message;

        if (message) {
            enqueueSnackbar(message, {
                variant: snackbarNotificationReducer.type,
                autoHideDuration: snackbarNotificationReducer.autoHideDuration || 5000,
            });
            dispatch(resetMessageStore());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [snackbarNotificationReducer]);

    return null;
};

export default SnackbarNotification;
